import { render, staticRenderFns } from "./LinkMiniIcon.vue?vue&type=template&id=45065cdf"
import script from "./LinkMiniIcon.vue?vue&type=script&lang=js"
export * from "./LinkMiniIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports